export default __webpack_public_path__ + "static/media/strategic1.82d50ded.png";